export default { sha: '3a08a7530531a217394121a7a07f9f2f5d1542cb', buildNumber: 'undefined' }
